<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title">UNITED COUNTIES BUSES</h1>
<p class="title1">A FLEET HISTORY, 1921–2014</p>
<p class="author"><span class="bold">DAVID BEDDALL</span></p>
<div class="img_container"><img alt="images" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Title.vue?38ce523e